"use client";

import { cn } from "@repo/ui";
import { Spinner } from "@repo/ui/components/spinner";
import { useLandingPreloaderReadiness } from "@shared/lib/use-preloader-readiness";
import {
	type PropsWithChildren,
	useCallback,
	useEffect,
	useState,
} from "react";

export function LandingDemoPreloader({ children }: PropsWithChildren) {
	const [overlayVisible, setOverlayVisible] = useState(true);
	const [fadeOut, setFadeOut] = useState(false);

	useLandingPreloaderReadiness(
		useCallback(() => {
			setFadeOut(true);
		}, []),
	);

	useEffect(() => {
		if (!fadeOut) {
			return;
		}
		const t = window.setTimeout(() => setOverlayVisible(false), 450);
		return () => window.clearTimeout(t);
	}, [fadeOut]);

	return (
		<>
			{overlayVisible ? (
				<div
					className={cn(
						"fixed inset-0 z-[10000] flex flex-col items-center justify-center gap-4 bg-background transition-opacity duration-500 ease-out",
						fadeOut
							? "pointer-events-none opacity-0"
							: "opacity-100",
					)}
				>
					<span className="sr-only">
						{fadeOut ? "" : "Loading experience"}
					</span>
					<Spinner className="size-10 text-primary" aria-hidden />
					<p className="text-sm text-muted-foreground" aria-hidden>
						Loading experience…
					</p>
				</div>
			) : null}
			{children}
		</>
	);
}
